import * as React from 'react';
import Pagination from './components/Pagination';
import { IPaginationProps } from './entities';

const BCPagination: React.FC<IPaginationProps> = React.memo(props => <Pagination {...props} />);

export { IPaginationProps };
export default BCPagination;
